<template>
    <empty  style="height: 100vh;">
        <loading size="24px" slot="description">信息处理中...</loading>
    </empty>
</template>
<script>
    import {mapMutations} from 'vuex';
    import {Empty,Loading} from 'vant';
    import { Base64 } from 'js-base64';
    export default {
        props:['authinfo','redirecturl'],
        components:{
            Empty,
            Loading
        },
        methods:{
            ...mapMutations([
                'setUserInfo'
            ]),
            handleAuthInfo:function(){
                let authinfo = Base64.decode(this.authinfo);
                let redirecturl = Base64.decode(this.redirecturl);

                if(redirecturl.indexOf('movecloud.cn') === -1 && redirecturl.indexOf('game.gomoku.mvsports.cn') === -1)
                {
                    window.location.replace(redirecturl)
                    return ;
                }
                // let token = this.cf.getToken();  
                // if(token){
                //     window.location.replace(redirecturl)
                //     return ;
                // }
                try {
                    authinfo    =   JSON.parse(authinfo)
                    
                    this.setUserInfo(authinfo);
                    
                    if(redirecturl.indexOf('game.gomoku.mvsports.cn') !== -1 || redirecturl.indexOf('h5.game.movecloud.cn') !== -1){
                        if(redirecturl.indexOf('h5.game.movecloud.cn') !== -1)
                        {
                            var shareConf = {
                                title: '全民骑跑虚拟竞技大赛',
                                path:
                                    '/pages/webviewsteps/index?src=https://h5.game.movecloud.cn/index',
                            }

                            wx.miniProgram.postMessage({ data: JSON.stringify(shareConf) });
                        } else {
                            var shareConf = {
                                title: '线上活动',
                                path:
                                    '/pages/webviewsteps/index?src='+redirecturl,
                            }

                            wx.miniProgram.postMessage({ data: JSON.stringify(shareConf) });
                        }

                        redirecturl = redirecturl.replace(/([\?&])authinfo=[^&]*/, '');
                        if (redirecturl.includes('?')) {
                            // 如果已经有 '?'，用 '&' 拼接新的参数
                            redirecturl += '&authinfo=' + this.authinfo
                        } else {
                            // 如果没有 '?'，用 '?' 拼接新的参数
                            redirecturl += '?authinfo=' + this.authinfo
                        }
                        window.location.replace(redirecturl)
                    } else {
                        window.location.replace(redirecturl)
                    }
                    
                }catch (e) {
                    console.log(e)
                }



                //如果5s中未处理成功 跳转到主页
                setTimeout(()=>{
                    this.$toast.fail("数据处理失败")
                    wx.miniProgram.reLaunch({
                        url:'/pages/index/index'
                    });
                },5e3)

            }
        },
        mounted() {
            this.$nextTick(()=>{
                this.handleAuthInfo();
            })



        }
    }
</script>
